import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  ContainerDivs,
  Link,
  SelectDropdownPlan
} from '../'

import Styles from './RetirementPlanGrid.css'


@CSSModules(Styles,{allowMultiple:true})
export default class RetirementPlanGrid extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  render() {
    const companies = Object.keys(config.plansSource).map((key, i) => {
      const companyConfig = {
        primary_plan_name: config.plansSource[key].primary_plan_name,
        logo: null,
        path: key,
      }
      try {
        companyConfig.logo = require(
          `../../../static/images/plans/${config.plansSource[key].path}.png`
        )
      }
      catch (e) {
        console.log('')
      }
      return companyConfig
    })

    //
    return (
      <ContainerDivs>
        <div styleName='cs-out'>

          { /* COMPANY SELECT DROPDOWN PICKER */ }
          <div styleName='cs-select-wrap'>
            <SelectDropdownPlan
              onChange={
                (val) => {
                  this.context.router.push(config.routes.plans + '/' + val.name)
                }
              }
            />
          </div>

          <div styleName='pos-rel'>
            { /* Company picker */ }
            <div styleName='company-picker-flex'>
              {
                companies.map((e, i)=>{
                  return (
                    <h3
                      key={'cmpny-' + i}
                      styleName={'company-picker-cell company-picker-actv'}
                    >
                      <Link
                        to={config.routes.plans + '/' + e.path}
                        title={e.primary_plan_name}
                      >


                        <div styleName='company-picker-cell-inner'>

                          <div styleName='company-picker-cell-grow'>
                            <div styleName='company-picker-img-wrap'>
                              { e.logo ?
                                  <img
                                    src={e.logo}
                                    alt={e.primary_plan_name}
                                    styleName='company-picker-img'
                                  /> :
                                  null
                              }
                            </div>
                            <div styleName='company-picker-label'>
                              {e.primary_plan_name}
                            </div>
                          </div>

                        </div>


                      </Link>
                    </h3>
                  )
                })
              }
            </div>
          </div>
          <div styleName='cs-tl-sub'>
            New plans added regularly
          </div>
        </div>
      </ContainerDivs>
    )
  }
}